<template>
    <div>
        <v-chart :options="options"/>
    </div>
</template>
<style>
.echarts {
  width: 300px;
  height: 300px;
}
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficotreemap",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'rotulo',
        'legendas',
		'dados',
        'total'
    ],
    data () {
        return {
            options : {
                // tooltip: {
                //     trigger: 'item',
				// 	formatter: '{a} <br/>{b} : {c} ({d}%)'
                // },
                //tooltip: {
                // trigger: 'item',
                //     formatter: function(info) {
                //         let value = parseFloat(info.value);      // valor do item 
                //         let percent = parseFloat(info.treePathInfo[info.treePathInfo.length - 1].value) / parseFloat(info.treePathInfo[0].value) * 100;
                //         return info.name + "<br/>" +
                //             "Valor: " + value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + "<br/>" +
                //             "Percentual: " + percent.toFixed(2) + "%";
                //     }
                // },

              tooltip: {
                    trigger: 'item',
                    formatter: (info) => {
                        let valor = parseFloat(info.value);
                        let percentual = this.total > 0 
                            ? (valor / this.total * 100).toFixed(2) 
                            : 0;

                        return `${info.name}<br/>
                                Valor: R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}<br/>
                                Percentual do total: ${percentual}%`;
                    }
                },

                legend: {
                    orient: 'vertical',
                    left: -5,
                    top: '30',
                    data: [],
                    textStyle: {
						fontSize: 8
					}
                },
                series: [
                    {
                    type: 'treemap',
                    data: [
                    ]
                    }
                ]



            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        legendas(){
            this.options.legend.data    			= this.legendas;
            this.options.series[0].name 			= this.rotulo;
			this.options.series[0].data 			= this.dados; 

            // atualiza tooltip já com o total vindo da prop
            this.options.tooltip.formatter = (info) => {
                let valor = parseFloat(info.value);
                let percentual = this.total > 0 
                    ? (valor / this.total * 100).toFixed(2) 
                    : 0;

                return `${info.name}<br/>
                        Valor: R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}<br/>
                        Percentual do total: ${percentual}%`;
            }
        }
    }    
}
</script>